import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-sql';
import 'prismjs/themes/prism.css';

import { registerField } from 'core/forms';

import styles from '../styles/formFieldCodeEditor.module.scss';

const handleHighlight = (code, lang = 'js') => {
  if (lang === 'jinja2') {
    return code.replace(/\{\{[^}]*\}\}/g, (match) => `<strong>${match}</strong>`);
  }

  return highlight(code, languages[lang]);
};

const FormFieldCodeEditor = ({
  fieldId,
  schema = {
    className: '',
    fontFamily: '"Fira code", "Fira Mono", monospace',
    fontSize: 12,
    isDisabled: false,
    lang: 'js',
    maxLength: null,
    placeholder: '',
  },
  updateField,
  value = '',
}) => (
  <div className={styles.element}>
    <Editor
      id={fieldId}
      value={value === null ? '' : value}
      onValueChange={updateField}
      placeholder={schema.placeholder}
      highlight={(code) => handleHighlight(code, schema.lang)}
      disabled={schema.isDisabled}
      maxLength={schema.maxLength}
      tabSize={2}
      padding={10}
      style={{
        fontFamily: schema.fontFamily || '"Fira code", "Fira Mono", monospace',
        fontSize: schema.fontSize || 12,
        minHeight: '12.5rem',
        resize: 'vertical',
      }}
    />
  </div>
);

FormFieldCodeEditor.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    lang: PropTypes.string,
    maxLength: PropTypes.number,
  }),
};

registerField('CodeEditor', memo(FormFieldCodeEditor));

export default FormFieldCodeEditor;
